import { createContext } from 'react'

export const EmploymentsContext = createContext({})
